import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('address-packstation-subform', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./address-packstation-subform')
    ),
);
